import moment from 'moment';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant'

const monthDefaultValue = {
    // 默认六月数据（不包括本月， 本月没有数据）
    [FORM_MAP.RANGE_TIME]: [
      moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD'),
      moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD')
    ],
    [FORM_MAP.RANGE_TIME_DIFF]: false,
    [FORM_MAP.ZONE]: ["255"],
    [FORM_MAP.REGION]: {
      regions: [],
      markets: ["255"],
      region_type: "market",
    },
    [FORM_MAP.SYSTEM]: ["255"],
    [FORM_MAP.CHANNEL]: ["255"],
    [FORM_MAP.LANGUAGE]: ['255'],
    [FORM_MAP.RANGE_TIME_TYPE]: "Month",
  } as any

export default monthDefaultValue;